import { SKU_SORTS, SkuSortSchema } from '@cult/schemas';
import { z } from 'zod';

export const marketSearchSchema = z.object({
  sort: SkuSortSchema.catch(SKU_SORTS.NEWEST),
  q: z.string().catch(''),
  // Client-side gate: show only SKUs the user can currently afford. Lives in URL state
  // (shareable/bookmarkable) but is never sent to the API — affordability is a client concern.
  affordable: z.boolean().catch(false),
});

export type MarketSearch = z.infer<typeof marketSearchSchema>;
